import { buildPlyrVideo } from "../sections";

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.body.dataset.template === "digestive-health") {
    buildPlyrVideo();
  }
});
